module.exports = {
  home: {
    nav1: "关于我们",
    nav2: "我们的客户",
    nav3: "我们的服务",
    nav4: "新闻资讯",
    nav5: "加入我们",
    nav6: "会计服务",
    nav7: "财务管理咨询",
    nav8: "税务服务",
    nav9: "审计与咨询服务",
    nav10: "特殊风险与会计管理服务",
    nav11: "商务服务",
    nav12: "人力资源服务",
    nav13: '法律咨询服务',
    nav14: 'IT服务',
    more: "更多",
    text: "您有任何需求可以可以发电邮和我们联系：info@accentuate.com.cn.我们一定会在第一时间给您回复。",
    icp: "京ICP备2023024411号"
  },
  join: {
    title: "人才战略",
    title1: "我们需要什么样的人才？",
    title2: "招聘信息-现在提供的岗位：",
    title3: "北京：初级会计顾问",
    title4: "职位描述",
    title5: "要求",
    text: "寻找出色的你，一起破浪行舟， 共同远航！",
    text1: "无论您是经验丰富的专业人士还是专业服务领域的“新人”，只要您有梦想，我们是帮助您实现梦想的地方。",
    text2: "我们会为所有申请者提供公平的竞争机会。所有员工都将受到高度尊重。",
    text3: "你将在国际化的工作环境中与资深专业人士共事，学习最好的专业实践，得到不同性质的各种工作和培训机会，当然您还将得到极具竞争力的薪酬回报。",
    text4: "我们致力于提供高品质的专业服务，因此我们只聘请专业的人才，他们应当主动、热情、聪明并且勤奋。",
    text5: "我们坚持最高的职业道德标准，因此所有合格的竞争者应该具备诚信、客观、专业胜任、保密这些核心品质。",
    text6: "我们要求有经验的申请者具有丰富的专业知识和背景，而对于新人我们更看重发展潜质，同时，所有员工都应该具备出色的沟通能力和团队合作技巧。",
    text7: "1.负责几个客户的会计和税务事宜",
    text8: "2.与外资客户就各种咨询的问题进行沟通",
    text9: "1.本科以上学历，财务相关专业",
    text10: "2.1-2年相关经验",
    text11: "3.英文读写能力",
    text12: "4.优秀的团队意识和快速的学习能力",
    text13: "5.主动和诚信",
  },
  introduce: {
    title: "埃深特是一家主要从事有关中国范围内财务，税务，审计，商务咨询的专业服务机构，总部位于北京，在上海香港等地都设有专门办事机构，在中国，正积极在全国范围内建立广泛的联合专业服务网络，目前我们的服务可以覆盖大多数主要城市。",
    text: "我们的理念是助力企业全球化发展，综合多年的国际业务经验和对中国市场的深刻理解和实践体验，我们致力于提供高质量的专业的财务，税务、审计，财务咨询，以及商业管理多方面的专业服务 为中国企业拓展海外业务，也为进入中国市场的外商及中国本土企业提供全方位一站式无忧解决方案。业务范围从企业设立、会计、审计、税务合规、人事薪酬、CFO服务等，到企业收购整合、，市场进入战略及商业咨询等等。在作为市场中的佼佼者，我们的服务不仅满足当地合规要求，同时为企业的高效运作提供坚强的后盾。",
    text1: "我们深刻认识到每一位客户都是独一无二的，并都有其独特的业务需求埃深特承诺将根据客户的不同业务需求，为客户提供个性化的财务解决方案。我们的专业人员将密切与您合作，以充分了解您独特的业务需求，从而提供满足您所需要的高时效、高质量的专业服务。我们作为客户可靠的合作伙伴，帮助客户在中国成长和成功。",
    text2: "我们的客户，尤其是中小型的外商投资企业，对我们服务的质量和性价比给予了高度评价，并且感谢我们为他们在中国的成功而做出的努力。正是由于客户的信任和支持，我们在中国的业务每年都在稳步增长。",
    text3: "埃深特为全球众多的跨国公司、公共机构、及迅速成长的公司提供符合国际和本地最佳实践的专业服务。"
  },
  product: {
    title: "我们的客户",
    text: "聚焦中国境内和境外投资，我们的客户覆盖各行各业，包含全球大型跨国公司、私营企业、中小型企业、上市公司以及创业公司等。无论外国还是本地投资企业，我们都会支持并协助我们的客户在中国发展与成长，提供优质的服务和丰富的资源以帮助他们在中国的业务发展。埃深特同时也会帮助中国企业进行海外拓展，特别是我们针对中东的商务财务市场提供专业服务，并且和中东财务领域伙伴进行了深度合作"
  },
  news: {
    title: "新闻资讯",
    title1: "财务会计",
    title2: "税务政策",
    title3: "人力资源",
    title4: '财政部加强企业数据资源相关会计处理 服务数字经',
    time: "2023年08月01日",
    title5: "IASB就收入准则发布实施后审议意见征询稿",
    time1: "2023年07月07日",
    title6: "财政部关于印发《企业会计准则解释第16号》的通知",
    time2: "2023年04月07日",
    title7: "关于延续实施外籍个人有关津补贴个人所得税政策的公告",
    time3: "2023年8月18日",
    title8: "支持小微企业和个体工商户发展税费优惠政策指引",
    time4: "2023年01月01日",
    title9: "人力资源社会保障部关于《修改<在中国境内就业的外国人参加社会保险暂行办法>的决定（征求意见稿）》公开征求意见的通知",
    time5: "2023年08月03日"
  },
  server: {
    title: "会计服务",
    title1: "财务管理咨询",
    title2: "税务服务",
    title3: "审计与咨询服务",
    title4: "特殊风险与会计管理服务",
    title5: "商务服务",
    title6: "人力资源服务",
    title7: "法律咨询服务",
    title8: "IT服务",
  },
  server1: {
    title: "首席财务官职能：",
    text: "埃深特可以帮助公司运营其财务职能。我们可以提供财务经理职能，用于计划、组织或直接控制财务活动，并可以提供临时财务管理服务，包括临时会计和行政支持。对于可能需要此类管理的时期，我们提供全面全面的首席财务官(CFO)职能。作为中小型企业需要专业人士在高级财务管理的层面获得专业支持。这种支持不仅是对月度财务账目、财务报表等进行审阅，同时也对企业内部控制、合规性以及更重要的管理决策进行财务支持。量身打造的个性化CFO职能服务可以根据您的具体要求，定期进行或者在特殊要求时进行，确保您的企业以成本高效的模式平稳运营。",
    title1: "财务管理:",
    text1: '埃深特在协助公司财务运营方面为您提供全面周到的服务。其中首先包括财务管理服务，关于资产的购置（投资），资本的融通（筹资）和经营中现金流量（营运资金），以及利润分配的管理；财务管理外包，包括会计和行政工作外包。',
    title2: '资金管理',
    text2: "中国的企业资产管理体系十分复杂。我们能够帮助企业制定有效的战略，来克服众多法律法规给企业在中国资本平稳运营上所带来的阻碍。",
    text3: "我们的资产管理服务帮助企业开立银行账户，包括加速付款、开立信贷账户、开立资本金账户、开通网上银行、开立外币存款账户以及开立人民币银行账户。",
    title3: "会计与记账",
    text4: "随着中国财务会计和国际化会计的趋同，在不断更新的立法和会计准则下，始终保持相对竞争优势对于很多公司来说是困难的。，专业干练的会计团队，使您能够以低成本来获取一套快速、精确、清晰和简洁的财务记账；在节约成本的同时，获得高效并专业的会计服务。我们将协助您建立标准的工作流程，在企业内部整合财务职能，并且以成本高效的方式指导您的业务及财务人员。同时，我们将会对您公司发生的任何财务问题给予灵活并“量体裁衣”的解决方案，为您业务的成功发展提供必要的基础保证。我们的预算团队能够帮助您建立全方位的预算管理体系、清晰地预算规划方案，助您尽快达成财务目标。我们会为您提供一套自上而下的精简预算流程，确保你的预算既规范又可靠。",
    title4: "财务系统支持",
    text5: "在当前竞争激烈的商业环境中，时间、资源和灵活性对成功至关重要。埃深特可以为您提供财务系统的解决方案，帮助您设置会计系统以及财务管理系统。基于云财务管理系统您可以进行立项、合同申请、合同收付款管理、报销流程管理等财务相关全流程管理。",
    title5: "员工短期外派服务",
    text6: "为了满足客户的需求，我们也提供了短期的员工外派服务。在员工放产假、或公司签订大单合同后总部未批准相应人员编制的增加，或在财务部或人力资源部人手短缺的情况下，埃深特中拥有丰富经验的专业工作人员都能在各种方面支持您的业务。"
  },
  server2: {
    title: "财务尽职调查",
    text: "无论是对目标公司进行独立评估，还是对潜在的商业伙伴进行背景调查，都通过全面的评估和尽职调查服务来降低开展业务的风险。",
    text1: "在并购或合资过程中，我们还可以提供战略建议，以实现整体上更协同的结果。基于我们在当地的专业知识和知识，加上我们在审计和财务管理方面的背景，我们提供了具有成本效益的解决方案，以了解与另一方做生意时的各种风险。",
    title1: '企业并购服务',
    text2: "埃深特在公司战略、企业融资、企业管理中积累的多年实战经验和专业知识使我们能够为您在收购兼并的各个范畴内提供一流的咨询建议和专业意见。与收购兼并相关的服务包括交易咨询服务、企业的并购与剥离、企业并购后的整合和财务尽职调查。",
    title2: '估价服务',
    text3: '我们提供多方面的评估服务。企业的评估服务旨在协助客户解决税务筹划及税务的合规问题、财务报告的申报、收购并购交易、企业重组以及解决各种争端等问题。需求最多的估价服务包括损失评估、知识产权估价和为了建立新的固定资产记录以作为并购价的分配，以及为确定资产的可投保金额所提供的资产评估服务。埃深特同时也为公共和私营机构提供特殊估价服务，包括特殊目的的资产重新改良及再利用，并协助您处置与购置特殊目的的资产。',
    title3: "企业融资",
    text4: "我们协助您更好的利用自有资本，增加盈利以及减少支出。我们提供全面的债务重组服务，主要包括高效率地与银行、债权人、供应商以及税务机关交涉。我们也为小型公司提供债务调解服务，以帮助他们通过重组营运而在市场中占据更有利的位置。另外，我们的企业并购、处置与融资服务能够为客户加强其经营方面的稳定性以及业务增长能力。"
  },
  server3: {
    title: "税务合规服务",
    text: "中国征收税种极为宽泛，不同行业及地区均有特殊规定。企业需要更简洁，更有效，更符合成本效益的方法来履行它们的合规责任。企业及个人所得税申报，增值税申报和税务专项申报等服务，可以有效帮助企业节约大量时间、成本和人力去了解和熟悉复杂的中国税收制度和监管框架，并避免因延迟和遗漏申报所造成的税务风险，罚款和滞纳金。",
    titles1: "企业所得税",
    tips: "企业所得税合规健康检查",
    tips1: "月度/季度企业所得税申报",
    tips2: "年度企业所得税纳税调整及报告",
    tips3: "税务专项申报",
    titles2: "增值税",
    tips4: "增值税合规健康检查",
    tips5: "增值税和本地附加税申报",
    titles3: "转让定价",
    tips6: "转让定价同期资料报告",
    tips7: "国别报告",
    titles4: "个人所得税",
    tips8: "个人所得税合规健康检查",
    tips9: "月度个人所得税申报",
    tips10: "年度个人所得税汇算清缴",
    tips11: "个人所得税追溯申报",
    tips12: "股票期权申报",
    title2: "税务咨询服务",
    text1: "税务咨询服务不仅需要熟悉各国的税务条款和对国际税务的高度认知，还要对本土税法有深入了解，以及国家间双边税收协定带来的益处。税务筹划策略需要具备丰富经验的税务专家参与，从而在提供跨境税务解决方案时满足客户的特别需求。",
    text2: "税务筹划为您的企业在合规的同时降低税务风险及合规成本。例如，跨境集团企业内部交易的税务处理，企业决策所带来的税务影响、利润汇回和税务风险控制等等。",
    tips13: "税务检查及税务清算协助服务",
    text3: "协助客户梳理税务检查及税务清算的重点关注事项、准备相关税务证明资料以支持其税务处理的合理性，并提出详细的应对方案，在政策允许的范围内尽可能地降低客户的损失。",
    tips14: "税收优惠咨询服务",
    text4: "在税收优惠、扣除事项及退税事项等方面为企业提供相关税务协助服务，特别是在政策不明确及税务机关具有自由裁量空间的领域，协助客户分析各种方案的税务影响，了解税务机关的政策口径，与各级税务机关进行充分沟通协商并协助完成相关税务申请及备案事宜。",
    tips15: "税务筹划服务",
    text5: "为了应对中国不断变化的税收法规，在华企业调整相应的税务规划显得特别重要。埃深特可以为您提供各个方面的税务筹划，可以帮助您在实现您的商业目的的同时，达到最有效的税务管理，并减少来自中国税务机关的关注和风险。",
    text6: "我们为客户提供全方位的税务服务，如：税务架构优化、企业并购重组中的税收筹划、与税务机关沟通及进行税务申报。同时我们在转让定价方面也有非常丰富的经验，使跨国企业可以在公司整体战略和中国税务体系之间达到平衡，从而减少税收风险。",
    text7: "我们与众多国际专业服务公司紧密合作，埃深特可以为企业提供非常有效率的税务尽职调查、海外税务筹划及公司设立等服务。",
    tips16: "兼并和收购税务咨询",
    text8: "企业重组税务筹划",
    text9: "股权转让税收筹划",
    text10: "税务尽职调查",
    tips17: '转让定价方案',
    text11: "转让定价筹划咨询",
    text12: "价值链税收优化管理",
    tips18: '国际税收服务',
    tips19: '境外投资税务筹划咨询',
    tips20: '利润汇回方案筹划咨询',
    tips21: '非贸项下境外付汇税务筹划咨询',
    title10: "税务培训服务",
    text13: "为了让企业或个人及时了解和掌握最新的财税政策，为企业及员工提供税务政策解读和实操培训服务。",
    text14: "埃深特埃深特拥有丰富的国内外雇员税务处理的经验，以及为跨国公司高管合理规划薪酬架构。埃深特深悟税务变化中错综复杂的程序，是您解决所有个人所得税相关问题的最好伙伴。无论您是自雇还是跨国公司雇员，我们都能为您提供最有效的税务咨询。",
    title11: "个人税务服务"
  },
  server4: {
    title: "鉴证与咨询服务",
    text: "我们能为客户提供符合海内外各类会计准则的综合审计服务，包括针对公认会计原则、国际财务报告准则、美国公认会计准则的差异出具财务报表、以及中国和香港的法定审计工作。我们不仅能为您提供国际水准的审计报告，同时还能提供审计之外的增值服务。通过审计过程中发现的涉及会计、财务、税务、法律、内控以及商业管理等各个层面可能存在的问题并提出建议。",
    text1: "另外，我们还负责企业上市前和上市后审计，并对有关财务报表出具审计报告。",
    title1: "中国法定审计",
    text3: "我们提供企业外部审计和内部审计服务，结合了具有针对性的财务舞弊调查和法务会计服务。同时还提供专项审计服务，例如外汇审计、版权审计或其他特殊目的的审计。"
  },
  server5: {
    title: "内部控制",
    text: "埃深特的专业咨询和实践指导可以帮助企业建立并加强内部控制。我们通过提供基于企业的控制环境、风险评估体系、控制活动、监督与复核、信息与沟通的内部控制框架来帮助企业实现有效的内部控制。",
    text1: "埃深特在系统解决方案与实施方面有着丰富的经验，能支持企业对整个系统的提升和完善。我们能够在适应您企业自身需求的前提下，协助您评估现存的财务风险，制定最妥当的资金管理战略，协助您应对相应的风险。我们对萨班斯法案第404条款方面的专业知识可以确保您公司在审计过程中完全遵循萨班斯法案。",
    title1: "会计准则、美国联交所和国际会计准则遵循服务",
    text3: "埃深特可以提供专业服务以满足客户在美国会计准则、美国联交所和国际会计准则方面的需求。我们可以在编制财务报表、满足上市公司合规性需求、会计准则之间的转换以及企业账目梳理等方面，为您提供专业的支持和保证。我们的团队与适用美国会计准则以及其他会计准则的公司均有着广泛的合作经验，对编制符合国际会计准则的财务报告也极富经验，能够为上市公司提供各种满足证监会法规的有力辅助。同时，雷博在账务清理、重建以及梳理混乱的账簿记录等方面也具有丰富的经验，能满足客户审计和遵循其适用准则的需求。"
  },
  server6: {
    text: "市场准入，公司设立以及维护",
    text1: "在中国大陆设立公司是一件具有挑战性的事情，您可能需要在专业人士的帮助下完成复杂的公司设立流程。在中国大陆，商业运营和政治环境紧密相连，因此在设立和运营公司时，公司需要透彻理解并完全遵守中华人民共和国的相关法律规定。",
    text2: "埃深特提并不局限于以下服务",
    text3: "市场准入",
    text4: "企业注册地址咨询",
    text5: '政府政策的相关咨询',
    text6: "提供您潜在合作伙伴，竞争对手的尽职调查以及企业信用调查",
    text7: "协助客户成立外商独资企业及其分支机构、内资企业、中外合资企业、中外合作企业以及外国机构驻华代表处，非盈利机构。年度申报",
    text8: '证照更新、证照变更等政府规定的相关注册服务',
    text9: "企业注销与破产清算",
    text10: "有时公司可能遇到突发事件，或者公司需要对业务进行适当的调整，在中国，公司的注销，清算以及破产，从来都不是简单的程序。雷博可以为公司的恢复计划提供建议及帮客户处理复杂的清算过程。在现在的商业环境下，公司的重整和转变与公司的破产有紧密联系，有时我们可以在其中发现挽救公司的机会。对于公司的破产和清算程序有着十分透彻的了解，同时我们寻找可替代资金来源方面有丰富的经验。我们还可以为客户提供债务重组计划书，解决公司的财务问题。"
  },
  server7: {
    text: "外籍人士的签证服务",
    text1: "中国的签证系统和劳动法规非常复杂，在这种情况下，公司不可避免的需要专业的指导以便顺利完成签证申请的相关程序。我们提供外籍人士就业许可的申请，变更以及家庭成员的签证服务。",
    text2: "社会保险服务",
    text3: '我们为外籍人士以及本土员工提供社会保险账户的开立和注销，个人社保清算，住房公积金注册，提取。',
    text4: '薪资处理服务',
    text5: "鉴于中国新劳动法的实施，企业对专业的国内薪酬管理服务需求与日俱增。埃深特将为您提供专业、快速并高度可靠的会计处理方法，消除新规章制度给您带来的各种忧虑，使您能够将更多精力集中在销售和企业发展方面。我们提供广泛的薪资处理服务，例如建立薪酬管理体系，以及具备为本地和外籍员工提供特定的服务等。",
    text6: "人力资源咨询服务",
    text7: "我们在处理相关事务方面有丰富的经验，同时对劳动法，税法及劳工法有着深刻的理解，因此我们可以帮助您有效的完成这些关键的步骤，包括公司假期管理，企业裁员，政策咨询等，为您的各种需要提供支持，确保您的公司可以平稳运营。",
    text8: "人力资源外包服务",
    text9: "为了客户能够降低人力成本，实现效率最大化，我们为客户提供人力资源服务外包服务，包括人事服务外包、人力(劳务)外包和人力资源专业管理外包等。"
  },
  server8: {
    text: "劳动法律咨询",
    text1: "劳动法涉及的内容很多，并且对员工来说十分重要，确保企业的优秀人力资源不至流失并不容易，因为存在着众多潜在竞争雇主。",
    text2: "工作中员工之间的纠纷，潜在的歧视，不公平待遇，内部冲突，职业风险虐待和其他很多类似方面都足以使企业走下坡路。而当企业拥有一位经验丰富的律师业务代表时，不仅能够高效率的处理问题，不再浪费时间，同时还能够激发员工的各种积极性。",
    text3: '企业法律顾问',
    text4: '埃深特，作为专业资深的服务业行家，一向旨在全面充分地了解客户的各种展望。我们了解客户在不同场合下可能产生的不同需求和各种必要的法律服务。因此，我们为客户提供全方位的法律咨询服务，以快速高效地解决客户的各类问题及需求。',
    text5: "我们致力于在既定的时间内为客户及时提供指导意见。我们的服务将为您节省时间和精力，无疑会在很大程度上改善您公司的运营，并快速提高您应对突发事件的能力。",
    text6: "其他法律服务",
    text7: "除了上面劳动和企业法律顾问提到的服务之外，我们能够提供其他的不同的综合法律服务，包括争端调解与咨询、商标与知识产权咨询服务、债务回收协助和诉讼支持。",
    text8: "我们以国际化的方法处理问题，使得我们能够在不同的细分市场中为您提供不同的服务。",
    text9: "更重要的是，如果您的需求超过我们服务上限，我们很乐意为您介绍多年来与我们建立了广泛合作关系的各大杰出企业。在埃深特，我们始终秉着客户至上的态度，为您服务。"
  }

};


// WEBPACK FOOTER //
// ./src/lang/language-zh.js